module.exports = __webpack_public_path__ + "media/Loops 90 Perc.e7f1c3ef.wav";